import { render } from "./DateDisplay.vue?vue&type=template&id=469e0902"
import script from "./DateDisplay.vue?vue&type=script&lang=js"
export * from "./DateDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
